import contentBlocksJson from './data/content-blocks.json';

type GdadContentBlocks = {
  meta: {
    source: string;
    generated_at: string;
  };
  role_levels_by_role: Record<string, string[]>;
  role_level_urls_by_key: Record<string, string>;
  role_level_content_by_key: Record<
    string,
    {
      intro: string;
      bullets: string[];
      grades: string[];
    }
  >;
  skill_content_by_key: Record<
    string,
    {
      skill: string;
      url: string;
      level: string;
      bullets: string[];
    }
  >;
};

const gdadContentBlocks = contentBlocksJson as GdadContentBlocks;

export const getRoleLevelsByRole = (role: string): string[] | undefined => {
  if (!role) {
    return undefined;
  }
  return gdadContentBlocks.role_levels_by_role?.[role];
};

export const getRoleLevelContent = (
  role: string,
  roleLevel: string,
):
  | {
      intro: string;
      bullets: string[];
      grades: string[];
    }
  | undefined => {
  if (!role || !roleLevel) {
    return undefined;
  }
  return gdadContentBlocks.role_level_content_by_key[`${role}||${roleLevel}`];
};

export const getRoleLevelUrl = (role: string, roleLevel: string): string | undefined => {
  if (!role || !roleLevel) {
    return undefined;
  }
  return gdadContentBlocks.role_level_urls_by_key?.[`${role}||${roleLevel}`];
};

export const getSkillContent = (
  role: string,
  roleLevel: string,
  skillId: string,
):
  | {
      skill: string;
      url: string;
      level: string;
      bullets: string[];
    }
  | undefined => {
  if (!role || !roleLevel || !skillId) {
    return undefined;
  }
  return gdadContentBlocks.skill_content_by_key[`${role}||${roleLevel}||${skillId}`];
};
